import { render, staticRenderFns } from "./ImportHistory.vue?vue&type=template&id=f207f29a&"
import script from "./ImportHistory.vue?vue&type=script&lang=js&"
export * from "./ImportHistory.vue?vue&type=script&lang=js&"
import style0 from "./ImportHistory.vue?vue&type=style&index=0&id=f207f29a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports